<template>
  <Modal
    :open="displayModal"
    title="Approve Video"
    :showEscapeButton="false"
    :showAcceptButton="true"
    acceptButtonText="Accept Video"
    :showDangerButton="true"
    dangerButtonText="Decline Video"
    @close="displayModal = false"
    @onSuccess="approveVideo"
    @onDanger="declineVideo"
    ref="modal"
    v-if="displayModal"
  >
    <div
      class="w-full py-4 px-4 rounded-lg text-white bg-gray-500 text-center"
      v-if="!data.youtube_id"
    >
      YouTube Preview Not Available
    </div>

    <YouTubePlayer
      v-if="data.youtube_id"
      :youtube_id="data.youtube_id"
      class="rounded-lg overflow-hidden"
    />

    <SegmentedControl
      :tabs="segmentedControlTabs"
      @selectedTab="tabSelected"
      class="mt-4"
    />

    <div class="grid grid-cols-3 gap-4 mt-4" v-if="activeTab === 'general'">
      <div class="col-span-3">
        <label for="title" class="block text-sm font-medium text-gray-700"
          >Video Title
          <span class="text-xs font-normal text-gray-400"
            >{{ data.title | count }} characters remaining</span
          >
        </label>
        <input
          type="text"
          name="title"
          id="title"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.title"
        />
      </div>

      <div class="col-span-3 md:col-span-1">
        <label for="price" class="block text-sm font-medium text-gray-700"
          >Default Price</label
        >
        <input
          type="number"
          name="price"
          id="price"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="price"
        />
      </div>

      <div class="col-span-3 md:col-span-2">
        <label for="rating" class="block text-sm font-medium text-gray-700"
          >Rating</label
        >
        <div class="flex">
          <div class="w-1/2">
            <input
              type="text"
              name="rating"
              id="rating"
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              v-model="rating"
              placeholder="3.5"
            />
          </div>
          <div class="w-1/2 flex justify-center items-center">
            <StarRating id="starRating" :rating="rating > 5 ? 0 : rating" />
          </div>
        </div>
      </div>

      <div class="col-span-3">
        <label for="description" class="block text-sm font-medium text-gray-700"
          >Video Narrative
        </label>
        <textarea
          type="textarea"
          name="description"
          id="description"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          rows="5"
          v-model="data.description"
        ></textarea>
      </div>
    </div>

    <div v-if="activeTab === 'network-pricing'">
      <div class="-mx-1 my-2">
        <span
          class="m-1 px-3 py-1 bg-blue-500 text-white text-sm rounded-full inline-block cursor-pointer hover:bg-blue-400 shadow-md"
          v-for="network in networksToDisplayAsAvailable"
          v-bind:key="network.id"
          v-show="network.displayPricingDefault"
          v-on:click="selectNetwork(network)"
        >
          <i class="fa fa-plus mr-1"></i>{{ network.name }}
        </span>
        <!-- <span
          class="m-1 px-3 py-1 bg-gray-500 text-white text-sm rounded-full inline-block cursor-pointer hover:bg-gray-400 shadow-md"
        >
          <i class="fa fa-magnifying-glass mr-1"></i> Search
        </span> -->
      </div>

      <div class="mt-4" v-if="selectedNetworks.length == 0">
        No networks currently selected.
      </div>

      <div class="mt-4 flex flex-col space-y-2">
        <div
          class="flex flex-row items-center content-center justify-between bg-gray-100 p-2 pl-4 rounded-lg"
          v-for="network in selectedNetworks"
          v-bind:key="network.id"
        >
          <div class="flex flex-row items-center content-center space-x-2">
            <i
              class="fa-regular fa-circle-minus cursor-pointer hover:text-gray-400"
              v-on:click="removeFromSelectedNetworks(index, network.id)"
            ></i>
            <div class=" flex items-center content-center">
              {{ network.name }}
            </div>
          </div>
          <div class="">
            <input
              class="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              type="number"
              v-model="perNetworkPricing[network.id]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-3 gap-4 mt-4" v-if="activeTab === 'advanced'">
      <div class="col-span-3">
        <label for="price" class="block text-sm font-medium text-gray-700"
          >Video Owner</label
        >
        <p class="text-sm text-gray-700 py-1">
          {{ data.user.name }}
          <span class="text-xs text-gray-500">({{ data.user.email }})</span>
        </p>
        <SearchListBox
          :dataArr="userCollection"
          placeholder="Type to search for a user..."
          resId="user"
          textKey="name"
          @onSearch="onSearch"
          @onSelect="onSelectItem"
        />
      </div>
      <div class="col-span-1">
        <label for="type" class="block text-sm font-medium text-gray-700"
          >Video Type</label
        >
        <select
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
          v-model="data.type"
        >
          <option value="eng">B-Roll (ENG)</option>
          <option value="stock">Stock</option>
        </select>
      </div>

      <div class="col-span-1">
        <label for="type" class="block text-sm font-medium text-gray-700"
          >YouTube Visibility</label
        >
        <select
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
          v-model="visibility"
        >
          <option value="public">Public</option>
          <option value="unlisted">Unlisted</option>
          <option value="privae">Private</option>
        </select>
      </div>

      <div class="col-span-3">
        <label for="embargo" class="block text-sm font-medium text-gray-700"
          >Embargo
        </label>
        <input
          type="text"
          name="embargo"
          id="embargo"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="embargo"
        />
      </div>

      <div class="col-span-3 flex flex-row space-x-4 items-center">
        <input
          name="excludeFromCreditAgreements"
          id="excludeFromCreditAgreements"
          type="checkbox"
          class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
          v-model="exempt_from_credit_agreements"
        />
        <label for="excludeFromCreditAgreements" class="sm:text-sm">
          Exclude this video from all credit agreements.
        </label>
      </div>

      <div class="col-span-3">
        <label
          for="decline_message"
          class="block text-sm font-medium text-gray-700"
          >Decline Message
        </label>
        <textarea
          type="textarea"
          name="decline_message"
          id="decline_message"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          rows="2"
          v-model="declineMessage"
        ></textarea>
      </div>

      <div class="col-span-3">
        <span
          for="decline_message"
          class="block text-sm font-medium text-gray-700"
        >
          Internal Data
        </span>
        <pre
          class="bg-gray-800 px-4 py-3 whitespace-normal text-white rounded-md mt-1"
          >{{ videoData }}</pre
        >
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";

import { mapActions } from "vuex";

import Modal from "@/components/Modal";
import YouTubePlayer from "@/components/media/components/YouTubePlayer";
import StarRating from "@/components/general/StarRating";
import SearchListBox from "@/components/SearchListBox";
import SegmentedControl from "@/components/general/SegmentedControl";

export default {
  data() {
    return {
      displayModal: false,
      modal: false,
      rating: 3.5,
      data: {},
      price: null,
      visibility: "public",
      exempt_from_credit_agreements: false,
      playlists: [],
      player: null,
      embargo: null,
      userCollection: [],
      user: null,
      declineMessage: null,
      activeTab: "general",
      networks: [],
      selectedNetworks: [],
      segmentedControlTabs: [
        {
          name: "General",
          type: "general"
        },
        {
          name: "Network Pricing",
          type: "network-pricing"
        },
        {
          name: "Advanced",
          type: "advanced"
        }
      ],
      perNetworkPricing: {}
    };
  },

  components: {
    Modal,
    YouTubePlayer,
    StarRating,
    SearchListBox,
    SegmentedControl
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-approve-modal-open", this.open);
      }.bind(this)
    );
    this.getNetworks();
  },

  destroyed() {
    this.$eventBus.$off("admin-approve-modal-open", this.open);
  },

  watch: {
    rating: function(val) {
      if (/[a-zA-Z]/.test(val)) {
        this.$swal(
          "Whoops!",
          "Your rating must not contain any letters.",
          "error"
        );
      }
      if (val < 0 || val > 5) {
        this.$swal("Whoops!", "Your rating must be between 0 and 5.", "error");
      }
    },
    perNetworkPricing: function(data) {
      if (this.data.perNetworkPrice !== null && data.length >= 0) {
        this.perNetworkPricing = {};
      }
    }
  },

  computed: {
    networksToDisplayAsAvailable() {
      let selectedNetworksIds = this.selectedNetworks.map(a => a.id);

      return this.networks.filter(item => {
        return selectedNetworksIds.indexOf(item.id) === -1;
      });
    },
    videoData() {
      return {
        videoId: this.data.id
      };
    }
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    close() {
      this.displayModal = false;
    },

    open(data) {
      this.selectedNetworks = [];
      this.perNetworkPricing = {};
      this.activeTab = "general";
      this.embargo = null;

      if (data.user.permanent_embargo) {
        this.embargo = data.user.permanent_embargo;
      }
      this.displayModal = true;
      this.data = data;
    },

    async getNetworks() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks?type=national"
      );
      this.networks = res.data;
    },

    async onSearch(searchText) {
      var data = {
        name: searchText
      };
      let res = await this.$http.post(
        Config.apiPath + "/api/v2/admin/users/search/stringers",
        data
      );
      this.userCollection = res.data;
    },
    async onSelectItem(item) {
      this.userCollection = []; // clear locations
      this.data.user = item;
      console.log(this.data.user);
    },
    tabSelected(tab) {
      console.log(tab);
      this.activeTab = tab;
    },
    selectNetwork(network) {
      this.selectedNetworks.push(network);
    },
    removeFromSelectedNetworks(index, networkId) {
      this.selectedNetworks.splice(index, 1);
      delete this.perNetworkPricing[networkId];
    },
    async approveVideo() {
      console.log("click");

      var data = {
        id: this.data.id,
        price: this.price,
        visibility: this.visibility,
        description: this.data.description,
        type: this.data.type,
        user: this.data.user,
        embargo: this.embargo,
        title: this.data.title,
        rating: this.rating,
        perNetworkPricing: this.perNetworkPricing,
        exempt_from_credit_agreements: this.exempt_from_credit_agreements
      };
      try {
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/admin/videos/approval/accept",
          data
        );

        this.close();

        this.$eventBus.$emit("admin-refresh-upcoming-videos");

        this.addToastMessage({
          title: "Success",
          text:
            "Video was approved and made available to media clients and YouTube!",
          type: "success"
        });
        // EventBus.$emit("admin-approve-video-refresh-data");
      } catch (e) {
        this.addToastMessage({
          title: "Error",
          text: "There has been an error approving this video, try again.",
          type: "error"
        });
      }
    },
    async declineVideo() {
      let result = await this.$swal({
        title: "Continue?",
        text: "Are you sure you want to decline this video?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, decline video."
      });

      if (result.isConfirmed) {
        var data = {
          id: this.data.id,
          declineMessage: this.declineMessage
        };
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/admin/videos/approval/decline",
          data
        );
        if (res.status == 200) {
          this.close();
          this.$eventBus.$emit("admin-refresh-upcoming-videos");
        }
      }
    }
  }
};
</script>
